"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var zipCodeFormats_1 = __importDefault(require("../data/zipCodeFormats"));
var punctuation = ' -';
var checkZipAgainstFormat = function (zip, format) {
    if (zip === void 0) { zip = ''; }
    if (format === void 0) { format = ''; }
    var zipIndex = 0;
    var formatIndex = 0;
    var formatted = '';
    while (zipIndex < zip.length || formatIndex < format.length) {
        var zipCh = zip[zipIndex];
        if (punctuation.indexOf(zipCh) >= 0) {
            zipIndex++;
            continue;
        }
        if (formatIndex >= format.length) {
            return null;
        }
        var formatCh = format[formatIndex];
        if (punctuation.indexOf(formatCh) >= 0) {
            formatted += formatCh;
            formatIndex++;
            continue;
        }
        var zipChIsLetter = (zipCh >= 'a' && zipCh <= 'z') || (zipCh >= 'A' && zipCh <= 'Z');
        var zipChIsNumber = zipCh >= '0' && zipCh <= '9';
        if (formatCh === 'A') {
            if (!zipChIsLetter) {
                return null;
            }
        }
        else if (formatCh === 'X') {
            if (!zipChIsLetter && !zipChIsNumber) {
                return null;
            }
        }
        else if (formatCh === '1') {
            if (!zipChIsNumber) {
                return null;
            }
        }
        else {
            throw new Error('Postal code format not understood: ' + format);
        }
        formatted += zipCh.toUpperCase();
        zipIndex++;
        formatIndex++;
    }
    return formatted;
};
var applyZipCodeFormats = function (zip, formats) {
    for (var _i = 0, formats_1 = formats; _i < formats_1.length; _i++) {
        var format = formats_1[_i];
        var formatted = checkZipAgainstFormat(zip, format);
        if (typeof formatted === 'string') {
            return formatted;
        }
    }
    return null;
};
var formatZipCode = function (country, zip) {
    var info = zipCodeFormats_1.default[country];
    if (!info || info.none) {
        return zip ? zip.toUpperCase() : null;
    }
    return applyZipCodeFormats(zip, info.formats);
};
exports.default = formatZipCode;
